// Copyright (c) StrangeBee 2023

import { Route as CustomTagsListRoute, RouteUser as CustomTagsListUserRoute } from './CustomTags/List';
import { Route as FunctionsListRoute, RouteUser as FunctionsListUserRoute } from './Functions/List';
import { Route as LinksListRoute, RouteUser as LinksListUserRoute } from './Links/List';
import { Route as SettingsRoute } from './Settings';
import { Route as OrganisationsUsersListRoute, RouteUser as OrganisationsUsersListUserRoute } from './Users/List';
import { Route as NotificationsRoute } from './Notifications/List';
import { Route as EndpointsRoute } from './Endpoints/List';
import { Route as AttachmentRoute } from './Attachments/List';
import { Route as TemplateRoute } from './Templates';

export default [
    OrganisationsUsersListRoute,
    OrganisationsUsersListUserRoute,

    TemplateRoute,

    CustomTagsListRoute,
    CustomTagsListUserRoute,

    SettingsRoute,

    NotificationsRoute,

    EndpointsRoute,

    FunctionsListRoute,
    FunctionsListUserRoute,

    AttachmentRoute,

    LinksListRoute,
    LinksListUserRoute,
];
